import React, { ButtonHTMLAttributes } from "react";
import Button from "../Button/Button";

interface UserMenuButtonComponentProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonText: string;
  customCSS?: string;
  customWidth?: boolean;
  /** Passed through to Button, which swaps the text for a spinner. */
  loading?: boolean;
}

const UserMenuButtonComponent: React.FC<UserMenuButtonComponentProps> = ({
  buttonText,
  customCSS,
  customWidth,
  ...rest
}) => {
  return (
    <Button
      className={` bg-black1  p-3 text-white ${
        customWidth ? "" : "w-fit"
      } px-4 py-1.5 rounded-[4px] active:bg-blue1 placeholder:text-xs ${customCSS}`}
      {...rest}
    >
      {buttonText}
    </Button>
  );
};

export default UserMenuButtonComponent;
